import ReasonsCancellationJustify from './reasons-cancellation-justify.entity';

export default class ReasonsCancellation {
  id: string;

  name: string;

  description: string;

  active: boolean;

  justifications?: ReasonsCancellationJustify[];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.active = obj.active || false;
    this.justifications = ReasonsCancellationJustify.ofList(obj.justifications || []);
  }

  public static of(obj: any): ReasonsCancellation {
    return new ReasonsCancellation(obj);
  }

  public static ofList(obj: any = []): ReasonsCancellation[] {
    return obj.map(this.of);
  }
}
